/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_File_Type_Not_AllowedInputs */

const en_error_file_type_not_allowed = /** @type {(inputs: Error_File_Type_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only JPEG, PNG or PDF files.`)
};

/**
* | output |
* | --- |
* | "Only JPEG, PNG or PDF files." |
*
* @param {Error_File_Type_Not_AllowedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_file_type_not_allowed = /** @type {((inputs?: Error_File_Type_Not_AllowedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_File_Type_Not_AllowedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_file_type_not_allowed(inputs)
});